import SupportIcon from '@atlaskit/icon/core/support';
import * as React from 'react';

export function SvgContactSupport() {
  return <SupportIcon label="" testId="ads-refreshed-icon" />;
}
